module.exports = __webpack_public_path__ + "static/media/accessibility-b2g-round.22cdc191.png";